import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-disc-play-2",
  "use": "icon-si-glyph-disc-play-2-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-disc-play-2\" id=\"icon-si-glyph-disc-play-2\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>Disc-play 2</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(2.000000, 0.000000)\" fill=\"#434343\">\n            <path d=\"M6.516,2.984 L10.141,7 L12.946,7 L6.492,0.027 L0.035,7 L2.842,7 L6.516,2.984 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M6.516,13.019 L2.809,9.031 L0.003,9.031 L6.471,15.934 L12.939,9.031 L10.133,9.031 L6.516,13.019 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-disc-play-2.svg
// module id = 523r
// module chunks = 62